document.addEventListener('DOMContentLoaded', () => {
  console.log("✅ inquire-button.js loaded");

  const checkInterval = setInterval(() => {
    const priceEl = document.querySelector(
      'price-list.price-list--product sale-price, .price-list.price-list--product .sale-price, .price-item--regular'
    );

    const buttonEl = document.querySelector(
      '.product-form__submit, .buy-buttons button[type="submit"], form[action*="/cart"] button[type="submit"]'
    );

    if (priceEl && buttonEl) {
      const priceText = priceEl.textContent.trim().replace(/\s+/g, ' ');
      const buttonText = buttonEl.textContent.trim();
      const numericPrice = parseFloat(priceText.replace(/[^\d.]/g, '')) || 0;

      console.log("💰 PRICE FOUND:", priceText);
      console.log("🛒 BUTTON FOUND:", buttonText);
      console.log("📊 Numeric price:", numericPrice);

      if (buttonText.toLowerCase().includes('add to cart') && numericPrice > 20000) {
        buttonEl.textContent = 'Inquire Now';
        buttonEl.classList.add('inquire-now-button');

        buttonEl.addEventListener('click', function (e) {
          e.preventDefault();

          
          const cleanUrl = (window.location.origin + window.location.pathname)
  .replace(/page:\s*/i, '')
  .trim();



          const message = "Hi, I'm interested in this product.\n\n" + "\u200B" + cleanUrl;

const whatsappUrl = `https://wa.me/16049077777?text=${encodeURIComponent(message)}`;

          window.open(whatsappUrl, '_blank');
        }, { once: true });

        clearInterval(checkInterval);
        console.log("✅ Inquire button applied");
      } else if (numericPrice <= 30000) {
        clearInterval(checkInterval);
        console.log("ℹ️ Price below threshold, keeping Add to cart");
      }
    } else {
      console.log("⏳ Waiting for price/button elements...");
    }
  }, 1500);
});


/* =========================================
   SWYM Wishlist – Inquire Now → WhatsApp
========================================= */

document.addEventListener("click", function (e) {
  const button = e.target.closest(".swym-button, .swym-is-button");
  if (!button) return;

  const buttonText = button.textContent.trim().toLowerCase();

  if (buttonText === "inquire now") {
    e.preventDefault();
    e.stopPropagation();

   
      
    const cleanUrl = (window.location.origin + window.location.pathname)
  .replace(/page:\s*/i, '')
  .trim();



    const message = "Hi, I'm interested in this product.\n\n" + "\u200B" + cleanUrl;

const whatsappUrl = `https://wa.me/16049077777?text=${encodeURIComponent(message)}`;

    window.open(whatsappUrl, "_blank");
  }
});